import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid #ff4242;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #fff8f9;
    border-color: #d02632;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(208, 38, 50, 0.15);
  }
`

export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  background: #ffecf0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 20px;
    height: 20px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.span`
  font-size: 1.6rem !important;
  font-weight: 600;
  color: #d02632;
  line-height: 1.4 !important;
`

export const Description = styled.span`
  font-size: 1.3rem !important;
  font-weight: 400;
  color: #101828;
  line-height: 1.5 !important;
`
